export default [
    {
        key: "dopolnitelniy_derzhatel",
        allArray: "allDerzhatelRulonaStoyka",
        activeArray: "activeDerzhatelRulonaStoyka",
        position: "top",
    },
];
